"use client";

import { cn } from "@/lib/utils";
import Image from "next/image";
import Link from "next/link";

type CategoryTileProps = {
	labelText?: string;
	labelTextClassName?: string;
	title: string;
	href?: string;
	icon?: string;
	dim?: boolean;
	status?: string;
};

const CategoryTile = ({
	labelText,
	labelTextClassName,
	title,
	href,
	icon,
	dim,
	status,
}: CategoryTileProps) => {
	const RenderedElement = status === "new" ? Link : "button";

	return (
		<RenderedElement
			href={href ? href : "#"}
			className={cn(
				"relative flex items-center justify-start gap-x-1.5 rounded-lg bg-white px-6 py-2",
				dim ? "cursor-not-allowed opacity-50" : ""
			)}
		>
			{icon && <Image src={icon} alt={title} width={4} height={4} className="h-4 w-4" />}
			<span className="text-sm font-medium text-gray-800">{title}</span>

			{labelText && labelTextClassName ? (
				<span className="absolute -right-5 -top-3 z-0">
					<span
						className={cn(
							"rounded bg-green-500 px-[5px] py-[1px] text-[10px] uppercase text-white",
							labelTextClassName
						)}
					>
						{labelText}
					</span>
				</span>
			) : null}
		</RenderedElement>
	);
};

export default CategoryTile;
